"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  /**
   * @property {string} display - Used for headings larger than 20px.
   */
  display: "\"SF UI Display\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",

  /**
   * @property {string} ui - Used for text and UI (which includes almost anything).
   */
  ui: "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\"",

  /**
   * @property {string} mono - Used for code and sometimes numbers in tables.
   */
  mono: "\"SF Mono\", \"Monaco\", \"Inconsolata\", \"Fira Mono\", \"Droid Sans Mono\", \"Source Code Pro\", monospace"
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS90eXBvZ3JhcGh5L2ZvbnRGYW1pbGllcy5qcyJdLCJuYW1lcyI6WyJkaXNwbGF5IiwidWkiLCJtb25vIl0sIm1hcHBpbmdzIjoiOzs7Ozs7ZUFBZTtBQUNiOzs7QUFHQUEsRUFBQUEsT0FBTyw0S0FKTTs7QUFNYjs7O0FBR0FDLEVBQUFBLEVBQUUseUtBVFc7O0FBV2I7OztBQUdBQyxFQUFBQSxJQUFJO0FBZFMsQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IHtcbiAgLyoqXG4gICAqIEBwcm9wZXJ0eSB7c3RyaW5nfSBkaXNwbGF5IC0gVXNlZCBmb3IgaGVhZGluZ3MgbGFyZ2VyIHRoYW4gMjBweC5cbiAgICovXG4gIGRpc3BsYXk6IGBcIlNGIFVJIERpc3BsYXlcIiwgLWFwcGxlLXN5c3RlbSwgQmxpbmtNYWNTeXN0ZW1Gb250LCBcIlNlZ29lIFVJXCIsIFJvYm90bywgSGVsdmV0aWNhLCBBcmlhbCwgc2Fucy1zZXJpZiwgXCJBcHBsZSBDb2xvciBFbW9qaVwiLCBcIlNlZ29lIFVJIEVtb2ppXCIsIFwiU2Vnb2UgVUkgU3ltYm9sXCJgLFxuXG4gIC8qKlxuICAgKiBAcHJvcGVydHkge3N0cmluZ30gdWkgLSBVc2VkIGZvciB0ZXh0IGFuZCBVSSAod2hpY2ggaW5jbHVkZXMgYWxtb3N0IGFueXRoaW5nKS5cbiAgICovXG4gIHVpOiBgXCJTRiBVSSBUZXh0XCIsIC1hcHBsZS1zeXN0ZW0sIEJsaW5rTWFjU3lzdGVtRm9udCwgXCJTZWdvZSBVSVwiLCBSb2JvdG8sIEhlbHZldGljYSwgQXJpYWwsIHNhbnMtc2VyaWYsIFwiQXBwbGUgQ29sb3IgRW1vamlcIiwgXCJTZWdvZSBVSSBFbW9qaVwiLCBcIlNlZ29lIFVJIFN5bWJvbFwiYCxcblxuICAvKipcbiAgICogQHByb3BlcnR5IHtzdHJpbmd9IG1vbm8gLSBVc2VkIGZvciBjb2RlIGFuZCBzb21ldGltZXMgbnVtYmVycyBpbiB0YWJsZXMuXG4gICAqL1xuICBtb25vOiBgXCJTRiBNb25vXCIsIFwiTW9uYWNvXCIsIFwiSW5jb25zb2xhdGFcIiwgXCJGaXJhIE1vbm9cIiwgXCJEcm9pZCBTYW5zIE1vbm9cIiwgXCJTb3VyY2UgQ29kZSBQcm9cIiwgbW9ub3NwYWNlYFxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/typography/fontFamilies.js
// module id = 61
// module chunks = 0